<mat-card [class.facebookPlayer]="videoSrc && !isLoading" [class.urlForm]="!videoSrc && !isLoading">
  <ng-container *ngIf="videoSrc && !isLoading">
    <mat-card-header [class.publicViewer]="!canChange" *ngIf="!widget.meta.hideTitle">
      <sn-icon class="facebook-icon" size="xl"> facebook </sn-icon>
      <button
        mat-icon-button
        *ngIf="canChange"
        icon="swap_horiz"
        [matTooltip]="'dashboard.operational.widgets.changeUrl' | t"
        matTooltipPosition="before"
        (click)="changeSrc()"
      >
        <mat-icon>swap_horiz</mat-icon>
      </button>
    </mat-card-header>
    <fb-video [attr.href]="videoSrc" width="auto" autoplay="true"> </fb-video>
  </ng-container>

  <ng-container *ngIf="!videoSrc && !isLoading">
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <mat-card-header>
        <mat-card-title
          *ngIf="!changeTitle; else editTitleWidget"
          [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
          matTooltipPosition="above"
          (dblclick)="editTitle()"
          class="editTitle"
          >{{ widget.name }}
          <sn-icon size="xs">edit</sn-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="url-input">
        <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="success" type="submit" [disabled]="form.invalid || !canChange">
          {{ 'common.submit' | t }}
        </button>
      </mat-card-actions>
    </form>
  </ng-container>

  <ng-container *ngIf="!videoSrc && isLoading">
    <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent"></mat-spinner>
  </ng-container>
</mat-card>
<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
